<template>
  <div class="row" v-if="auth.can('HOME_PAGE')">
    <h3 class="mb-20">Statistiques Générals</h3>

    <!-- <button
      class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
      type="button"
      v-on="{ click: handleLogin }"
    >
      Sign In Now
    </button> -->
    <!-- <WhatHappening /> -->

    <!-- <div
      class="card mb-25 border-0 rounded-0 bg-white welcome-support-desk-box"
    >
      <div
        class="card-body p-15 p-sm-20 p-md-25 p-lg-30 pt-xl-50 pb-xl-50 ps-xl-40 ps-xl-40 letter-spacing"
      >
        <div class="row align-items-center">
          <div class="col-12">
            <div class="content">
              <h2 class="fw-semibold mb-8">Statistiques Générals</h2>

              <div class="row list justify-content-center">
                <div class="col-md-6">
                  <rangedate-picker
                ref="myInput"
                format="YYYY-MM-DD"
                i18n="EN"
                :preset-ranges="presetRanges"
                :captions="captions"
              /> 
                </div>

                <div class="col-md-6">
                  <button
                    style="margin-top: 22px"
                    class="btn btn-primary"
                    @click="FilterData"
                  >
                    Chercher
                  </button>
                  <button
                    style="margin-top: 22px"
                    class="btn btn-danger"
                    @click="ClearFilterData"
                  >
                    Annuler
                  </button>
                </div> 
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black fs-13 text-uppercase"
              >
                Total Utilisateurs
              </span>
              <h4 class="mb-0 fw-black text-primary-emphasis"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>

          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#27F535' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Clients
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>

          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Colis
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>

          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Colis Ramassés
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Produits Stock
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons Réception
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total  Bons Livraison
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons Livraison (Stock)
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons d'envoie
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons distribution
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons paiment (Client)
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons paiment (Zone)
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons Retour (Agence)
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>

          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Bons Retour (Client)
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Factures
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Virements
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Réclamations
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Demandes Retours
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 mb-15">
            <div class="p-15 bg-dynamic" :style="{ '--bg-color': '#f2f1f9' }">
              <span
                class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
              >
                Total Demandes Ramassages
              </span>
              <h4 class="mb-0 fw-black text-primary"><i class="flaticon-sterile-box"></i> 200</h4>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="col-12 mb-25">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="row align-items-end g-3">
            <div class="col-md-4 col-sm-6">
              <label class="form-label fw-medium fs-13 text-uppercase text-dark-emphasis mb-1">
                Date début
              </label>
              <input
                type="date"
                class="form-control"
                v-model="searchSDate"
              />
            </div>
            <div class="col-md-4 col-sm-6">
              <label class="form-label fw-medium fs-13 text-uppercase text-dark-emphasis mb-1">
                Date fin
              </label>
              <input
                type="date"
                class="form-control"
                v-model="searchEDate"
              />
            </div>
            <div class="col-md-4 col-sm-12 d-flex gap-2">
              <button
                class="btn btn-primary fw-medium flex-fill"
                @click="FilterData"
                :disabled="isLoader"
              >
                <span
                  v-if="isLoader"
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i v-else class="ri-search-line me-1"></i>
                {{ isLoader ? "Chargement..." : "Chercher" }}
              </button>
              <button
                class="btn btn-outline-danger fw-medium flex-fill"
                @click="ClearFilterData"
                :disabled="isLoader"
              >
                <i class="ri-close-line me-1"></i> Annuler
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <StatsBoxes :dashData="dataDash" />

    <!-- chart parcels -->
    <div class="col-md-6">
      <ParcelCharts />
    </div>
    <div class="col-md-6">
      <UsersDataChart />
    </div>
    <div class="col-12">
      <LastMonthsChart />
    </div>

    <!-- <div class="row">
      <div class="col-lg-6 col-xxxl-6 col-md-6">
        <ExpectedEarnings />
      </div>
      <div class="col-lg-6 col-xxxl-6 col-md-6">
        <AverageDailySales />
      </div>
      <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-12">
        <RevenueThisMonth />
      </div>
      <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-12">
        <NewCustomersThisMonth />
      </div>
    </div> -->

    <!-- <WeeklySales />

    <div class="col-xxl-4">
      <SalesByPOSLocation />
    </div>
    <div class="col-xxl-4">
      <TopSellingProducts />
    </div>
    <div class="col-xxl-4">
      <WebsiteVisitors />
    </div>
    <div class="col-xxl-6">
      <ProductsOrders />
    </div>
    <div class="col-xxl-6">
      <StockReport />
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "vue";

import WhatHappening from "../../components/Dashboard/Ecommerce/WhatHappening.vue";

import ExpectedEarnings from "../../components/Dashboard/Ecommerce/ExpectedEarnings.vue";

import AverageDailySales from "../../components/Dashboard/Ecommerce/AverageDailySales.vue";

import RevenueThisMonth from "../../components/Dashboard/Ecommerce/RevenueThisMonth.vue";

import NewCustomersThisMonth from "../../components/Dashboard/Ecommerce/NewCustomersThisMonth.vue";

import StatsBoxes from "../../components/Dashboard/Ecommerce/StatsBoxes/index.vue";

import WeeklySales from "../../components/Dashboard/Ecommerce/WeeklySales.vue";

import SalesByPOSLocation from "../../components/Dashboard/Ecommerce/SalesByPOSLocation.vue";

import TopSellingProducts from "../../components/Dashboard/Ecommerce/TopSellingProducts/index.vue";

import WebsiteVisitors from "../../components/Dashboard/Ecommerce/WebsiteVisitors.vue";

import ProductsOrders from "../../components/Dashboard/Ecommerce/ProductsOrders/index.vue";

import StockReport from "../../components/Dashboard/Ecommerce/StockReport/index.vue";

import ParcelCharts from "./ParcelCharts.vue";
import LastMonthsChart from "./LastMonthsChart.vue";
import UsersDataChart from "./UsersDataChart.vue";

import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";

export default defineComponent({
  name: "EcommercePage",
  components: {
    // WhatHappening,
    // ExpectedEarnings,
    // AverageDailySales,
    // RevenueThisMonth,
    // NewCustomersThisMonth,
    StatsBoxes,
    // WeeklySales,
    // SalesByPOSLocation,
    // TopSellingProducts,
    // WebsiteVisitors,
    // ProductsOrders,
    // StockReport,
    ParcelCharts,
    LastMonthsChart,
    UsersDataChart,
  },

  setup() {
    const auth = useAuthStore();

    const dataDash = reactive({
      Totalcolis: 0,
      TotalRamasse: 0,
      Totalusers: 0,
      Totalclients: 0,
      TotalFournisseurs: 0,
      TotalProduits: 0,
      TotalSelfProduits: 0,
      TotalBonRecetion: 0,
      TotalBL: 0,
      TotalBLSupp: 0,
      TotalBLStock: 0,
      TotalBENV: 0,
      TotalBDisctr: 0,
      TotalBonPaie: 0,
      TotalBonZPaie: 0,
      TotalBonRetourAgence: 0,
      TotalBonRetourCust: 0,
      TotalInvoices: 0,
      TotalTransfer: 0,
      TotalClaim: 0,
      TotalRtnRequest: 0,
      TotalPickRequest: 0,
    });

    // Declare missing variables
    const isLoader = ref(false);
    const searchSDate = ref("");
    const searchEDate = ref("");

    // Any setup logic can go here
    const handleLogin = async () => {
      // console.log(localStorage.getItem("authToken"));
      console.log("User data:", auth.token, auth.user);
      // const res = await api.get("/api/auth/SituationColis");
      // console.log("Situation Colis:", res.data);
    };

    function FilterData() {
      getData();
    }
    function ClearFilterData() {
      searchSDate.value = "";
      searchEDate.value = "";
      getData();
    }
    async function getData() {
      isLoader.value = true;
      await api
        .get(
          `/api/auth/DashData?searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}`
        )
        .then((response) => {
          // handle response here, e.g. set a reactive variable
          // data.value = response.data;
          Object.assign(dataDash, response.data);
        })
        .catch((error) => {
          // handle error here, e.g. set an error flag
          // errorFlag.value = true;
          console.log(error);
        })
        .finally(() => {
          isLoader.value = false;
        });
    }
    return {
      handleLogin,
      FilterData,
      ClearFilterData,
      getData, // Export getData so it's used
      isLoader,
      searchSDate,
      searchEDate,
      dataDash,
      auth,
    };
  },
});
</script>